import { createContext, use } from 'react';
import { isBoolean } from 'lodash-es';

export const BlockchainGamePausedContext = createContext(false);

export const useIsBlockchainGamePaused = () => {
  const context = use(BlockchainGamePausedContext);
  if (!isBoolean(context)) {
    throw new Error(
      'useIsBlockchainGamePaused must be used within a BlockchainGamePausedContext'
    );
  }
  return context;
};
